export const getURLParams = (url = window.location?.hash ?? '') => {
  let hashUrl = url;
  if (hashUrl) {
    hashUrl = hashUrl.replace(/^http[^#]+(#\/.*)$/, '$1');
  }
  return new URLSearchParams('?' + ((hashUrl ?? '').split('?')[1] ?? ''));
};
